<div class="container">
  <div class="row">
    <div class="col-main col-lg-4 col-sm-6 mr-auto ml-auto">
      <div class="card card-register">
        <h3 class="title">{{'signin'|traduccion}}</h3>
        <form class="register-form" [formGroup]="form" (ngSubmit)="login()">
          <label>{{'email'|traduccion}}</label>
          <div class="input-group form-group-no-border" [ngClass]="{'input-group-focus':focus===true}">
            <div class="input-group-prepend">
              <span class="input-group-text">
                <i class="nc-icon nc-email-85"></i>
              </span>
            </div>
            <input formControlName="usernameOrEmail" name="usernameOrEmail" type="text" class="form-control" placeholder="Email"
              (focus)="focus=true" (blur)="focus=false">
          </div>
          <div *ngIf="usernameOrEmail.invalid && (usernameOrEmail.dirty || usernameOrEmail.touched)" class="text-danger">
            <small *ngIf="usernameOrEmail.errors.required">{{'email.errors.required'|traduccion}}<br></small>
            <small *ngIf="usernameOrEmail.errors.email">{{'email.errors.email'|traduccion}}<br></small>
          </div>
          <label>{{'password'|traduccion}}</label>
          <div class="input-group form-group-no-border" [ngClass]="{'input-group-focus':focus1===true}">
            <div class="input-group-prepend">
              <span class="input-group-text">
                <i class="nc-icon nc-key-25"></i>
              </span>
            </div>
            <input formControlName="password" name="password" type="password" class="form-control" placeholder="Password" (focus)="focus1=true"
              (blur)="focus1=false">
          </div>
          <div *ngIf="password.invalid && (password.dirty || password.touched)" class="text-danger">
            <small *ngIf="password.errors.required">{{'password.errors.required'|traduccion}}<br></small>
            <small *ngIf="password.errors.minlength">{{'password.errors.minlength'|traduccion}}<br></small>
          </div>
          <button [disabled]="!form.valid" class="btn btn-outline-neutral btn-block btn-round">{{'signin'|traduccion}}</button>
        </form>
        <div class="forgot">
          <a (click)="_goTo('signup')" class="btn btn-link text-info">{{'want_signup'|traduccion}}</a>
        </div>
        <div class="forgot">
          <a (click)="_goTo('reset')"  class="btn btn-link btn-terciary">{{'forgot_password?'|traduccion}}</a>
        </div>
      </div>
    </div>
  </div>
  <div class="footer register-footer text-center">

  </div>
</div>